<script setup lang="ts">
import { useCandidateStore } from "@/store/candidate";
const candidateStore = useCandidateStore();

definePage({
	name: "Skills",
});

const formItems = computed(() => candidateStore.formUser.skills);
</script>

<template lang="pug">
.page
	.form-wrapper
		modern-form
			template(#logo)
				.logo-placeholder
			template(#contentInner)
				form-comp.form-inputs
					template(v-for="(form, _index) in formItems.getItems", :key="_index")
						.row
							.group
								label Skills
								multiselect-form(
									v-model="form.skillsArr",
									mode="tags",
									:searchable="true",
									:create-option="true",
									:close-on-select="true",
									:options="form.skillsArr",
									:append-to-body="true"
								)
			template(#action)
				slot
	.right-side
		img(src="@/assets/image/auth/reg/7.png")
		//- input-img(
		//- 	:old-image="candidateStore.registerImageSrc",
		//- 	@set-image="onSetImage",
		//- 	@delete="onDeleteImage"
		//- )
</template>

<style lang="scss" scoped>
.page {
	@include candidate-profile-page;
}
</style>
